import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import { useDispatch } from 'react-redux';
import DragNDropColumns from 'src/components/DragNDropColumns';
import DraggableImageDisplay from 'src/components/DragRowDisplay/Image';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EnumLinkType } from '@/src/types/common/linkType';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getOptionsImage,
  onCollapseOpen,
  onErrorChange,
  onOptionsImageOnChange,
  onOptionsImageOnSort,
} from '../slice';

import { validateOptionsImage } from '../tools';

import { getI18nFromGeneral } from '@/src/tools/tools';
import styles from './style.module.less';
import { Checkbox } from 'antd';

const OptionsImage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    specificError = {},
    isOnPrimaryLanguage,
    disabled,
    hideEdit,
  } = props;

  const { enableMultiOptionsImage = false, optionLabelModules = [] } = data;

  const _d = useDispatch();
  const renderContent = (data, index, labelIndex) => {
    const { draggableId, linkImage, optionLabelValue } = data || {};

    const imageErrorArray = specificError[`${draggableId}_imageError`] || [];
    return (
      <Section key={draggableId} className={styles.section}>
        <DraggableImageDisplay
          title={optionLabelValue}
          imgOnChange={(img) =>
            handleOnChange(labelIndex, index, {
              linkImage: img,
              linkType: EnumLinkType.None,
              draggableId,
            })
          }
          linkImage={linkImage}
          error={imageErrorArray}
          disabled={disabled}
          hideEdit={hideEdit}
        />
      </Section>
    );
  };

  const handleOnChange = (labelIndex, index, data) => {
    _d(onOptionsImageOnChange({ labelIndex, index, data }));
  };

  const handleOnEnableMultiOptionChange = (enableMultiOptionsImage) => {
    _d(onOptionsImageOnChange({ enableMultiOptionsImage }));
  };

  const onOptionImageSort = (obj, labelIndex) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    _d(onOptionsImageOnSort({ labelIndex, from: oldIndex, to: newIndex }));
  };

  return optionLabelModules.length > 0 ? (
    <div>
      {isOnPrimaryLanguage ? (
        <>
          <Section className={styles.optionImageSection}>
            <div className={styles.optionImageDesc}>
              <Checkbox
                checked={enableMultiOptionsImage}
                onChange={(e) => {
                  handleOnEnableMultiOptionChange(e?.target?.checked);
                }}>
                {getI18n('salesChannelProductContent.index.optionImgTitle')}
              </Checkbox>
            </div>
            <ItemWrapper>
              <div>
                {getI18n('salesChannelProductContent.index.optionImageDesc')}
              </div>
            </ItemWrapper>
          </Section>

          {enableMultiOptionsImage &&
            optionLabelModules.map((i, labelIndex) => (
              <DragNDropColumns
                hideTitleRightFunction
                title={` ${getI18n('salesChannelProductContent.index.label')} ${
                  labelIndex + 1
                } - ${i.optionLabel}`}
                key={i.optionLabelUuid}
                childGenerate={(data, index) =>
                  renderContent(data, index, labelIndex)
                }
                data={i.optionLabelLinkModules || []}
                droppableId={`optionsImage-${i.optionLabelUuid}`}
                onSort={(obj) => onOptionImageSort(obj, labelIndex)}
                hideAdd
                onAdd={() => {
                  console.log('onAdd');
                }}
                addText=''
                hideDrag={disabled}
              />
            ))}
        </>
      ) : (
        <div>
          {optionLabelModules.map((i, labelIndex) =>
            i.optionLabelLinkModules.map((data, index) =>
              renderContent(data, index, labelIndex),
            ),
          )}
        </div>
      )}
    </div>
  ) : (
    ''
  );
};

export default ErrorProcessingHOC(OptionsImage, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.optionsImage,
  getContent: getOptionsImage,
  title: getI18nFromGeneral('general.hOCTitle.optionsImage'),
  validation: validateOptionsImage,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
